if (!customElements.get('adev-testimonials')) {
    customElements.define('adev-testimonials', class adevTestimonials extends HTMLElement {
        constructor() {
            super();
        }

        initSlider(){
            const carouselEl = this.querySelector('[data-adev-testimonials="items"]');

            this.slider = new Flickity(carouselEl, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true
            });

            this.slider.on('change', () => {
                const videos = this.querySelectorAll('adev-video-tag');
                videos.forEach(video => {
                    video.pause();
                });
            });
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
        }

        shopifyCustomizerInit(){
            if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (e) => {
                    const block = e.detail;

                    const blockId = block.blockId;
                    const sectionId = block.sectionId;

                    const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                    
                    if (blockElement) {
                        const index = blockElement.getAttribute('data-index');
                        this.slider.select(index);
                    }
                });

                document.addEventListener('shopify:block:deselect', (e) => {
                    const block = e.detail;

                    const blockId = block.id;
                    const sectionId = block.sectionId;
                });
            }
        }

        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}